import React, { useContext, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useFormState } from 'react-final-form';
import * as T from 'prop-types';
import HeaderAndError from '../../../commons/form-fields/HeaderAndError';
import GenericTextInputField from '../../../commons/form-fields/GenericTextInputField';
import GenericSelectInputField from '../../../commons/form-fields/GenericSelectInputField';
import FieldLabelAndError from '../../../commons/form-fields/FieldLabelAndError';
import GenericFileUploadField from '../../../commons/form-fields/GenericFileUploadField';
import { AuthContext } from '../../../commons/auth/AuthContext';
import { uploadResume } from '../../onboardingRoutes';
import { getCurrencyOptionsByCountry } from '../../../commons/CountryUtils';

export const ProfileInfoFormSection = (props) => {
    const routeMatch = useRouteMatch();
    const { url } = routeMatch.params;
    const authContext = useContext(AuthContext);
    const [resumeUploaded, setResumeUploaded] = useState();
    const [resumeUploadError, setResumeUploadError] = useState();
    const { values } = useFormState();

    const currencyOptions = getCurrencyOptionsByCountry(
        props.consultantCountry
    );

    return (
        <div className="max-w-4xl mx-auto bg-white px-6 py-1 md:mt-3 md:mb-6 rounded shadow-md text-sm">
            <HeaderAndError label="Profile Information" />
            <GenericTextInputField
                name="info.profile.website"
                label="Website/Blog"
                type="text"
            />
            <div className="md:grid md:grid-cols-3 md:gap-6">
                <div className="col-span-3 sm:col-span-1">
                    <div className="grid grid-cols-10 gap-0">
                        <div className="col-span-7">
                            <GenericTextInputField
                                name="info.profile.billingRate"
                                label="Billing Rate"
                                type="number"
                                validateAndRequiredNumber
                            />
                        </div>
                        <div className="col-span-3 mt-5">
                            <GenericSelectInputField
                                name="info.profile.currency"
                                initialValue={
                                    values?.info?.profile?.currency ??
                                    currencyOptions?.[0]?.value
                                }
                                options={currencyOptions}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-span-3 sm:col-span-2">
                    <div className="row-span-2 gap-y-0">
                        <FieldLabelAndError label={'Resume'} />
                        <GenericFileUploadField
                            name="info.profile.resumeFile"
                            accept={
                                'application/pdf, .doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                            }
                            onChangeCallback={(files, resetInputState) => {
                                uploadResume(url, files, authContext)
                                    .then(() => {
                                        setResumeUploaded(true);
                                        setResumeUploadError();
                                    })
                                    .catch((error) => {
                                        resetInputState();
                                        setResumeUploaded(false);
                                        setResumeUploadError(
                                            error.response?.data?.message
                                        );
                                        console.log(error);
                                    });
                            }}
                        />
                        {resumeUploaded && (
                            <div
                                className={'ml-2 text-green-700 italic text-xs'}
                                data-testid="resume-upload-success"
                            >
                                {' '}
                                Uploaded Successfully{' '}
                            </div>
                        )}
                        {resumeUploaded === false && (
                            <div
                                className={'ml-2 text-red-700 italic text-xs'}
                                data-testid="resume-upload-failure"
                            >
                                {' '}
                                {resumeUploadError === 'File too large'
                                    ? `${resumeUploadError}. Upload <20 MB file.`
                                    : 'An error occurred while uploading. Kindly retry or verify the file.'}{' '}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

ProfileInfoFormSection.propTypes = {
    consultantCountry: T.string,
};
